/*
 * @Author: seven.zhang 
 * @Date: 2019-02-13 14:34:02 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-04-16 17:46:04
 * api管理
 */
import request from './request.js';
// import qs from 'qs'
export default {
    // ==================================== 公共接口 ====================================
    // 获取城市列表
    getCity: () => request({ url: '/common/getCity', method: 'post' }),
    // 获取全部房企
    getCompany: () => request({ url: '/common/getCompany', method: 'post' }),

    // ==================================== 房企拿地监控系统 ====================================

    //监控时间
    getLandTime: (data = {}) => request({ url: '/takelandmonitor/getLastWeek', method: 'post', data }),
    //房企拿地属性占比
    getLandType: (data = {}) => request({ url: '/takelandmonitor/landTypePro', method: 'post', data }),
    //土地成交状况
    getLandTransStatus: (data = {}) => request({ url: '/takelandmonitor/landTransStatus', method: 'post', data }),
    //最新土地成交
    getLandTranData: (data = {}) => request({ url: '/takelandmonitor/LandTranData', method: 'post', data }),
    //房企拿地TOP10
    takeLandTop: (data = {}) => request({ url: '/takelandmonitor/takeLandTop', method: 'post', data }),
    //房企本周拿地 top100
    getLandTopHun: (data = {}) => request({ url: '/takelandmonitor/getLandTopHun', method: 'post', data }),
    //出让面积top10
    getLandSaleAreaTen: (data = {}) => request({ url: '/takelandmonitor/LandSaleAreaTen', method: 'post', data }),
    //土地出让幅数 top10
    getlandSaleFrame: (data = {}) => request({ url: '/takelandmonitor/landSaleFrame', method: 'post', data }),

    //获取城市分布
    getLandData: (data = {}) => request({ url: '/takelandmonitor/getLandData', method: 'post', data }),
    //通过城市获取城市的地块
    getLandCityDetail: (data = {}) => request({ url: '/takelandmonitor/getLandCityDetail', method: 'post', data }),


    // 列表页
    //房企拿地列表--图表统计
    getLandCountChart: (data) => request({ url: '/takelandmonitor/landCountChart', method: 'post', data }),
    //房企拿地监控列表 -- 列表数据
    landCountList: (data) => request({ url: '/takelandmonitor/landCountList', method: 'post', data }),



    // ==================================== 房企项目开工监控系统 ====================================
    // 数据统计时间-30天
    getHomeDate: (data = {}) => request({ url: '/projectstartmonitor/getHomeDate', method: 'post', data }),
    //项目开工统计
    homeWorkCount: (data) => request({ url: '/projectstartmonitor/homeWorkCount', method: 'post', data }),
    //开工项目类型占比
    homeTypePro: (data) => request({ url: '/projectstartmonitor/homeTypePro', method: 'post', data }),
    //房企开工建面
    companyHomeArea: (data) => request({ url: '/projectstartmonitor/companyHomeArea', method: 'post', data }),
    //城市开工建面
    cityHomeArea: (data) => request({ url: '/projectstartmonitor/cityHomeArea', method: 'post', data }),
    //开工项目分布图 - 城市
    getHomeCity: (data) => request({ url: '/projectstartmonitor/getHomeCity', method: 'post', data }),
    //房企开工项目 top100
    companyHomeStart: (data) => request({ url: '/projectstartmonitor/companyHomeStart', method: 'post', data }),
    //最新开工项目
    latestStartHome: (data) => request({ url: '/projectstartmonitor/latestStartHome', method: 'post', data }),
    // 项目开工分布图 
    getHomeData: (data) => request({ url: '/projectstartmonitor/getHomeData', method: 'post', data }),
    //最新项目招标
    latestTenderHome: (data) => request({ url: '/projectstartmonitor/latestTenderHome', method: 'post', data }),


    // 列表页
    //项目开工列表 -- 图表数据
    getHomeChart: (data) => request({ url: '/projectstartmonitor/getHomeChart', method: 'post', data }),
    //项目监控列表 -列表页
    getHomeList: (data) => request({ url: '/projectstartmonitor/getHomeList', method: 'post', data }),


    // ==================================== 全装修市场监控系统 ====================================
    //全装修统计时间
    getCountTime: () => request({ url: '/decoratemarket/getCountTime', method: 'post' }),
    //全装修项目建面top10城市
    getDecorateBuildTopTenCity: (data) => request({ url: '/decoratemarket/getDecorateBuildTopTenCity', method: 'post', data }),
    //全装修项目建面top10房企
    getDecorateBuildTopTenCompany: (data) => request({ url: '/decoratemarket/getDecorateBuildTopTenCompany', method: 'post', data }),
    //房企全装修交付覆盖率（环形嵌套）
    decorateBuildCompanyCover: (data) => request({ url: '/Decoratemarket/decorateBuildCompanyCover', method: 'post', data }),
    //获取全装修的面积还有套数 以及环比（双折线图）
    getDecorateAreaAndCount: (data) => request({ url: '/decoratemarket/getDecorateAreaAndCount', method: 'post', data }),
    //新开盘全装修项目列表（表格）
    getNewOpenDecorationProject: (data) => request({ url: '/decoratemarket/getNewOpenDecorationProject', method: 'post', data }),
    //全装修项目面积趋势（饼图）
    getDecorationAreaDirection: (data) => request({ url: '/decoratemarket/getDecorationAreaDirection', method: 'post', data }),
    getDecorationStandardDirection: (data) => request({ url: '/decoratemarket/getDecorationStandardDirection', method: 'post', data }),

    getDecorationStandardDirectionCate: (data) => request({ url: '/Decoratemarket/getDecorationStandardDirectionCate', method: 'post', data }),

    //全装修项目分布图（热力图）
    getDecorationProjectSpread: (data) => request({ url: '/decoratemarket/getDecorationProjectSpread', method: 'post', data }),

    //全装修项目分布图（新）
    getDecorationProjectSpreadNew: (data) => request({ url: '/decoratemarket/getDecorationProjectSpreadNew', method: 'post', data }),



    // 列表页
    //根据输入参数获取全装修、物业统计、趋势数据
    getProjectDataByInput: (data) => request({ url: '/decoratemarket/getProjectDataByInput', method: 'post', data }),
    //获取全装修最新列表
    getNewDecorateList: (data) => request({ url: '/decoratemarket/getNewDecorateList', method: 'post', data }),


    // ==================================== 我的业绩报告 ====================================
    // 获取合作伙伴的开工建面排行
    getPartnerBuild: (data) => request({ url: '/report/getPartnerBuild', method: 'post', data }),
    // 获取公司合作伙伴落地项目前10
    getCompanyPartnerProject: (data) => request({ url: '/report/getCompanyPartnerProject', method: 'post', data }),
    // 企业中标分布（热力图）
    getCompanyHomeSpread: (data) => request({ url: '/report/getCompanyHomeSpread', method: 'post', data }),
    // 百强房企合作占比（水滴图）
    getCompanyPartnerCover: (data) => request({ url: '/report/getCompanyPartnerCover', method: 'post', data }),
    // 当年企业中标项目数量，销售额 还有环比（折柱图）
    getRecentYearCountAndTotalSale: (data) => request({ url: '/report/getRecentYearCountAndTotalSale', method: 'post', data }),
    // 获取合作伙伴动态列表
    getCompanyPartnerNew: (data) => request({ url: '/report/getCompanyPartnerNew', method: 'post', data }),
    // 获取企业logo
    getCompanyLogo: () => request({ url: '/report/getCompanyLogo', method: 'post' }),


    // ==================================== 招标采购 ====================================
    // 获取所在城市
    getProvinceAndCity: () => request({ url: '/common/getProvinceAndCity', method: 'post' }),
    // 获取招标采购行业
    getInvitePurchaseIndustry: () => request({ url: '/decoratemarket/getInvitePurchaseIndustry', method: 'post' }),

    //获取招标采购列表
    getInvitePurchaseList: (data) => request({ url: '/decoratemarket/getInvitePurchaseList', method: 'post', data }),
    //获取招标采购统计数据-图表
    getInvitePurchaseSumAndCount: (data) => request({ url: '/Decoratemarket/getInvitePurchaseSumAndCount', method: 'post', data }),

    //获取跳转大屏url
    getJumpUrl: () => request({ url: '/bidding/url', method: 'post' }),


    // ==================================== 详情 ====================================
    // 获取详情
    getDetail: (data) => request({ url: '/takelandmonitor/landDetail', method: 'post', data }),

    // 登录
    getLoginToken: (data) => request({ url: '/user/login', method: 'post', data }),



    // ==================================== 研究报告 ====================================
    // 报告列表
    getReportList: (data) => request({ url: '/report/getReportList', method: 'post', data }),
    // 报告详情
    getReportDetail: (data) => request({ url: '/report/getReportDetail ', method: 'post', data }),
}